import { ApolloClient, ApolloLink, createHttpLink } from "@apollo/client";
import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";
import { setContext } from "@apollo/client/link/context";
import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";
import { getActiveUserIndex } from "utils/getActiveUserIndex";
import { getApolloCache } from "./getApolloCache";

if (window.SAM._env_.REACT_APP_ENVIRONMENT === "local") {
	// Adds messages only in a dev environment
	loadDevMessages();
	loadErrorMessages();
}

const httpLink = createHttpLink({
	uri: window.SAM._env_.REACT_APP_BASE_GRAPHQL_URL,
	credentials: "include",
});

const samContextLink = setContext((_, { headers }) => {
	return {
		headers: {
			...headers,
			["SAM-Context"]: window.btoa(
				JSON.stringify({ user_index: getActiveUserIndex() })
			),
		},
	};
});

const removeTypenameLink = removeTypenameFromVariables();

const link = ApolloLink.from([
	removeTypenameLink,
	samContextLink.concat(httpLink),
]);

export const apolloClient = new ApolloClient({
	link,
	cache: getApolloCache(),
});
